angular.module('cian.metroBrowser').directive('metroChange', ['$sce', function($sce) {
  return {
    scope: {},
    template: require('../../templates/metro-svg-browser.change.html'),
    templateNamespace: 'svg',
    restrict: 'A',
    bindToController: {
      changeData: '<',
    },
    controller: [function() {
      this.trust = (...args) => $sce.trustAsHtml.apply(this, args);
    }],
    controllerAs: 'changeCtrl'
  };
}]);



// WEBPACK FOOTER //
// ./src/components/metro-browser/src/scripts/cian.metro-svg-browser.change.dir.js